import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Radio, Paper, Text, CheckIcon } from '@mantine/core'
import { DateInput } from '@mantine/dates'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { getAllStatusesList, storeStatuses } from '../../../../../services/status'
import LoadingData from '../../../../ui/LoadingData'
import dayjs from 'dayjs'

const defaultVal = {
  order_id: null,
  status_id: null,
  status_type: 1,
  paid_date: null,
  notify: false,
  notes: null,
}

const FormAdjustPaymentStatus = ({ onCloseForm }) => {
  const { summary } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [loadingStatus, setLoadingStatus] = useState(true)
  const [paymentStatusList, setPaymentStatusList] = useState([])
  const [formData, setFormData] = useState(defaultVal)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitUpdatePaymentStatus = async (form) => {
    setLoadingForm(true)
    const payload = {
      order_id: form.order_id,
      status_id: Number(form.status_id),
      status_type: 1,
      paid_date: form.paid_date !== null ? dayjs(form.paid_date).format('YYYY-MM-DD') : '',
      notify: false,
      notes: null,
    }
    try {
      const response = await storeStatuses(payload)
      if (response.success) {
        onCloseForm()
        dispatch(getOrderDetail(orderId))
        notificationSuccess('Update Order Successfully', 'This data has been updated')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetPaymentStatusList = async () => {
    setLoadingStatus(true)
    const params = {
      'filter[status_type][is]': 1
    }
    try {
      const response = await getAllStatusesList(params)
      setPaymentStatusList(response.data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingStatus(false)
    }
  }

  useEffect(() => {
    handleGetPaymentStatusList()
  }, [])

  useEffect(() => {
    if (summary) {
      handleSetForm(summary)
    }
    // eslint-disable-next-line
  }, [summary])

  const handleSetForm = (value) => {
    const dataDetail = {
      order_id: orderId,
      status_id: value.paymentStatusId.toString(),
      status_type: 1,
      paid_date: value.paymentStatusDate !== null ? new Date(value.paymentStatusDate) : null,
      notify: false,
      notes: null,
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const mappingStatusPayment = (dataPayment) => {
    if (dataPayment.length > 0) {

      const mappingDataPayment = (data) => {
        const remapStatus = data.map((val, index) => {
          return (
            <Paper shadow="xs" radius="md" withBorder p="md" key={index} mb={12}>
              <Radio size='sm' icon={CheckIcon} value={val.attributes.id.toString()} label={<Text fz={12} fw='500' tt='capitalize' c='gray.7'>{val.attributes.name}</Text>} />
            </Paper> 
          )
        })

        return remapStatus
      }

      return (
        <Box>
          <Box mb='md'>
            <Radio.Group
                value={formData.status_id}
                onChange={(val) => handleChangeForm('status_id', val)}
                name="status_id"
                label="Payment Status"
                icon={CheckIcon}
                withAsterisk
                size='xs'
              >
                {mappingDataPayment(dataPayment)}
            </Radio.Group>
          </Box>
          <Box mb='md'>
            <DateInput
              name='paid_date'
              value={formData.paid_date}
              label='Paid Date'
              placeholder='DD/MM/YYYY'
              valueFormat="DD/MM/YYYY"
              onChange={(val) => handleChangeForm('paid_date', val)}
              size='xs'
              clearable
            />
          </Box>
          <Box mt={20}>
            <Flex justify='flex-end'>
              <Group>
                <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
                <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitUpdatePaymentStatus(formData)}>{summary ? 'Update' : 'Create'}</Button>
              </Group>
            </Flex>
          </Box>
        </Box>
      )
    }
    
  }

  return (
    <Box>
      {loadingStatus ? <LoadingData /> : mappingStatusPayment(paymentStatusList)}
    </Box>
  )
}

export default FormAdjustPaymentStatus